import React from 'react';
import { formatNumber } from '../../../utils/formatters';
import './TeamStats.css';

const TeamStats = ({ binaryInfo, directInfo, loading }) => {
  if (loading) {
    return <div className="team-stats-loading">Loading team stats...</div>;
  }

  const stats = [
    {
      label: 'Direct Referrals',
      value: directInfo?.directReferrals || 0,
      icon: '👥'
    },
    {
      label: 'Total Team',
      value: directInfo?.teamCount || 0,
      icon: '🌐'
    },
    {
      label: 'Direct Business',
      value: formatNumber(directInfo?.directBusiness || 0),
      unit: 'USDT',
      icon: '💰'
    },
    {
      label: 'Left Directs',
      value: binaryInfo?.leftDirects || 0,
      icon: '⬅️'
    },
    {
      label: 'Right Directs',
      value: binaryInfo?.rightDirects || 0,
      icon: '➡️'
    }
  ];

  return (
    <div className="team-stats">
      <h3 className="team-stats-title">Team Overview</h3>
      <div className="team-stats-grid">
        {stats.map((stat, idx) => (
          <div key={idx} className="team-stat-item">
            <span className="team-stat-icon">{stat.icon}</span>
            <div className="team-stat-content">
              <span className="team-stat-value">
                {stat.value}
                {stat.unit && <span className="team-stat-unit">{stat.unit}</span>}
              </span>
              <span className="team-stat-label">{stat.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TeamStats;
